import Vue from 'vue';
import draggable from 'vuedraggable';

const components = {
    draggable,
    AppAutocomplete: () => import('./components/AppAutocomplete.vue'),
    AppWrapper: () => import('./components/AppWrapper.vue'),
    AppDivider: () => import('./components/AppDivider.vue'),
    AppCopyButton: () => import('./components/AppCopyButton.vue'),
    AppSection: () => import('./components/AppSection.vue'),
    AppRow: () => import('./components/AppRow.vue'),
    AppField: () => import('./components/AppField.vue'),
    AppFieldset: () => import('./components/AppFieldset.vue'),
    AppText: () => import('./components/AppText.vue'),
    AppSwitch: () => import('./components/AppSwitch.vue'),
    AppGroup: () => import('./components/AppGroup.vue'),
    AppChip: () => import('./components/AppChip.vue'),
    AppTooltip: () => import('./components/AppTooltip.vue'),
    AppList: () => import('./components/AppList.vue'),
    AppLacuna: () => import('./components/AppLacuna.vue'),
    AppAlert: () => import('./components/AppAlert.vue'),
    AppAlertButton: () => import('./components/AppAlertButton.vue'),
    AppButton: () => import('./components/AppButton.vue'),
    AppButtonCancel: () => import('./components/AppButtonCancel.vue'),
    AppButtonClose: () => import('./components/AppButtonClose.vue'),
    AppLogoutButton: () => import('./components/AppLogoutButton.vue'),
    AppCard: () => import('./components/AppCard.vue'),
    AppScrollbar: () => import('./components/AppScrollbar.vue'),
    AppWysiwyg: () => import('./components/AppWysiwyg.vue'),
    AppVideo: () => import('./components/AppVideo.vue'),
    AppPdf: () => import('./components/AppPdf.vue'),
    AppFitText: () => import('./components/AppFitText.vue'),
    AppLink: () => import('./components/AppLink.vue'),
    AppImage: () => import('./components/AppImage.vue'),
    AppMediaFilePreview: () => import('./components/AppMediaFilePreview.vue'),
    AppMediaItemPreview: () => import('./components/AppMediaItemPreview.vue'),
    AppTable: () => import('./components/table/AppTable.vue'),
    AppTablePanel: () => import('./components/table/AppTablePanel.vue'),
    AppPageHeader: () => import('./components/AppPageHeader.vue'),
    AppParamSelector: () => import('./components/AppParamSelector.vue'),
    AppProgress: () => import('./components/AppProgress.vue'),
    AppQuerySelector: () => import('./components/AppQuerySelector.vue'),
    AppQuestionnaire: () => import('./components/AppQuestionnaire.vue'),
    AppQuestion: () => import('./components/AppQuestion.vue'),
    AppFileDrop: () => import('@/components/AppFileDrop.vue'),
    AppFilePreview: () => import('@/components/AppFilePreview.vue'),
    AppEditableRow: () => import('@/components/AppEditableRow.vue'),
    AppChart: () => import('./components/AppChart.vue'),
    TextAnimationLoader: () => import('./components/TextAnimationLoader.vue'),
    //
    KanbanColumn: () => import('./components/layouts/parts/KanbanColumn.vue'),
    KanbanBoard: () => import('./components/layouts/parts/KanbanBoard.vue'),
    //
    DisplayString: () => import('./components/display/String.vue'),
    DisplayBoolean: () => import('./components/display/Boolean.vue'),
    DisplayNumber: () => import('./components/display/Number.vue'),
    DisplayMoney: () => import('./components/display/Money.vue'),
    DisplayDate: () => import('./components/display/Date.vue'),
    DisplayDatetime: () => import('./components/display/Datetime.vue'),
    DisplayPercentage: () => import('./components/display/Percentage.vue'),
    DisplayContent: () => import('./components/display/Content.vue'),
    DisplayPhoneNumber: () => import('./components/display/PhoneNumber.vue'),
    DisplayEmailAddress: () => import('./components/display/EmailAddress.vue'),
    DisplayLink: () => import('./components/display/Link.vue'),
    DisplayEnum: () => import('./components/display/Enum.vue'),
    DisplayFee: () => import('./components/display/Fee.vue'),
    //
    EditBoolean: () => import('./components/edit/Boolean.vue'),
    EditString: () => import('./components/edit/String.vue'),
    EditMoney: () => import('./components/edit/Money.vue'),
    EditNumber: () => import('./components/edit/Number.vue'),
    EditDate: () => import('./components/edit/Date.vue'),
    EditDatetime: () => import('./components/edit/Datetime.vue'),
    EditParagraph: () => import('./components/edit/Paragraph.vue'),
    EditPercentage: () => import('./components/edit/Percentage.vue'),
    EditSelection: () => import('./components/edit/Selection.vue'),
    EditContent: () => import('./components/edit/Content.vue'),
    EditFile: () => import('./components/edit/File.vue'),
    EditEnum: () => import('./components/edit/Enum.vue'),
    //
    FieldString: () => import('./components/fields/String.vue'),
    FieldEnum: () => import('./components/fields/Enum.vue'),
    FieldNumber: () => import('./components/fields/Number.vue'),
    FieldBoolean: () => import('./components/fields/Boolean.vue'),
    FieldDescription: () => import('./components/fields/Description.vue'),
    FieldDescriptionModal: () => import('./components/fields/DescriptionModal.vue'),
    FieldDate: () => import('./components/fields/Date.vue'),
    FieldDatetime: () => import('./components/fields/Datetime.vue'),
    FieldMoney: () => import('./components/fields/Money.vue'),
    FieldPercentage: () => import('./components/fields/Percentage.vue'),
    FieldToggle: () => import('./components/fields/Toggle.vue'),
    FieldYear: () => import('./components/fields/Year.vue'),
    FieldTaxYear: () => import('./components/fields/TaxYear.vue'),
    FieldMonth: () => import('./components/fields/Month.vue'),
    FieldDay: () => import('./components/fields/Day.vue'),
    FieldLookup: () => import('./components/fields/Lookup.vue'),
    FieldUrl: () => import('./components/fields/Url.vue'),
    FieldEmail: () => import('./components/fields/Email.vue'),
    FieldPhoneNumber: () => import('./components/fields/PhoneNumber.vue'),
    FieldCurrency: () => import('./components/fields/Currency.vue'),
    FieldOptions: () => import('./components/fields/Options.vue'),
    FieldPopupWysiwyg: () => import('./components/fields/PopupWysiwyg.vue'),

    ActionMenu: () => import('./components/ActionMenu.vue'),

    // Skeleton
    Skeleton: () => import('./components/skeleton/Skeleton.vue')
};

Object.entries(components).forEach(([name, component]) => Vue.component(name, component));
